// ── À remplacer après déploiement Google Apps Script ──────────────────────────
var BIS_ENDPOINT = 'https://script.google.com/macros/s/AKfycbyJyH8143cgVpQvCFL80x3qTzQg6H6_KRp38hyOZ3yQ6tf3DMHZbZUOG4z-4BvGigjh/exec';
// ──────────────────────────────────────────────────────────────────────────────

(function () {
  function init() {
    document.querySelectorAll('.back-in-stock').forEach(setupWrapper);
    document.addEventListener('variant:change', handleVariantChange);
  }

  function setupWrapper(wrapper) {
    var trigger = wrapper.querySelector('.back-in-stock__trigger');
    var formWrapper = wrapper.querySelector('.back-in-stock__form-wrapper');
    var form = wrapper.querySelector('.back-in-stock__form');

    if (trigger && formWrapper) {
      trigger.addEventListener('click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!expanded));
        formWrapper.hidden = expanded;
        if (!expanded) {
          var emailInput = formWrapper.querySelector('.back-in-stock__email');
          if (emailInput) emailInput.focus();
        }
      });
    }

    if (form) form.addEventListener('submit', handleSubmit);
  }

  function handleVariantChange(event) {
    var variant = event.detail && event.detail.variant;
    var productInfo = event.target && event.target.closest('product-info');
    var sectionId = productInfo && productInfo.dataset.section;
    var wrapper = sectionId && document.getElementById('back-in-stock-' + sectionId);
    if (!wrapper) return;

    var variantInput = wrapper.querySelector('.back-in-stock__variant-input');
    if (variantInput && variant) variantInput.value = variant.id;

    if (!variant || !variant.available) {
      wrapper.classList.add('back-in-stock--visible');
    } else {
      wrapper.classList.remove('back-in-stock--visible');
      var formWrapper = wrapper.querySelector('.back-in-stock__form-wrapper');
      var trigger = wrapper.querySelector('.back-in-stock__trigger');
      if (formWrapper) formWrapper.hidden = true;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }
  }

  function handleSubmit(event) {
    event.preventDefault();
    var form = event.target;
    var wrapper = form.closest('.back-in-stock');
    var successMsg = wrapper.querySelector('.back-in-stock__success');
    var errorMsg = wrapper.querySelector('.back-in-stock__error');
    var submitBtn = form.querySelector('.back-in-stock__submit');

    submitBtn.disabled = true;
    submitBtn.textContent = '...';
    errorMsg.hidden = true;

    var payload = {
      email:         form.querySelector('[name="email"]').value.trim(),
      product_id:    form.querySelector('[name="product_id"]').value,
      product_title: form.querySelector('[name="product_title"]').value,
      variant_id:    form.querySelector('.back-in-stock__variant-input').value,
      page_url:      window.location.href,
      shop:          window.Shopify ? window.Shopify.shop : location.hostname,
    };

    // Form POST via iframe cachée → contourne le CORS sans ouvrir d'onglet
    var iframeName = 'bis-sink-' + Date.now();
    var iframe = document.createElement('iframe');
    iframe.name = iframeName;
    iframe.style.display = 'none';
    document.body.appendChild(iframe);

    var hiddenForm = document.createElement('form');
    hiddenForm.method = 'POST';
    hiddenForm.action = BIS_ENDPOINT;
    hiddenForm.target = iframeName;
    hiddenForm.style.display = 'none';

    Object.keys(payload).forEach(function (key) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = payload[key];
      hiddenForm.appendChild(input);
    });

    document.body.appendChild(hiddenForm);
    hiddenForm.submit();

    setTimeout(function () {
      document.body.removeChild(hiddenForm);
      document.body.removeChild(iframe);
    }, 5000);

    form.hidden = true;
    successMsg.hidden = false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
